import React, { useState } from "react"
import axios from "axios"
import styled from "styled-components"
import { getCookie } from "../../utils/helpers"

const BlogCta = styled.div`
    &.blue-inverted{
        .ehi-pillar-block{
            background-color: #01c4df;
            border-radius: 0;
            color: #fff;
        }
    }
    &.green-inverted{
        .ehi-pillar-block{
            background-color: #30c592;
            border-radius: 0;
            color: #fff;
        }
    }
    &.orange-inverted{
        .ehi-pillar-block{
            background-color: #ffc170;
            border-radius: 0;
            color: #fff;
        }
    }
    &.red-inverted{
        .ehi-pillar-block{
            background-color: #e4463c;
            border-radius: 0;
            color: #fff;
        }
    }
    &.gray-inverted{
        .ehi-pillar-block{
            background-color: #666;
            border-radius: 0;
            color: #fff;
        }
    }
    &.green{
        .ehi-pillar-block{
            background-color: #9bedd1;
            border-radius: 0;
            .form-group{
                label{
                    color: #075f41;
                }
            }
        }
    }
    &.red{
        .ehi-pillar-block{
            background-color: #ffdddb;
            border-radius: 0;
            .form-group{
                label{
                    color: #66130e;
                }
            }
        }
    }
    &.blue{
        .ehi-pillar-block{
            background-color: #9feef9;
            border-radius: 0;
            .form-group{
                label{
                    color: #0a5059;
                }
            }
        }
    }
    &.orange{
        .ehi-pillar-block{
            background-color: #fdf1d7;
            border-radius: 0;
            .form-group{
                label{
                    color: #7b4e12;
                }
            }
        }
    }
    &.gray{
        .ehi-pillar-block{
            background-color: #f4f4f4;
            border-radius: 0;
        }
    }
    .ehi-pillar-block{
        max-width: 720px;
        margin: 40px auto 0;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        padding: 1.6rem;
        >div:last-child{
            margin-bottom: 1rem;
        }
        >h2{
            margin-top: 1.2rem;
        }
        p{
            line-height: 1.6;
            font-size: 1rem;
        }
    }
    h2{
        font-weight: 800;
    }
    .employee-num input {
        width:100%;
    }
    .county-select {
        font-size: 14px;
        height: 50px;
        border: 1px solid #000;
        border-radius: 5px;
        padding: 0 10px;
    }
    @media screen and (max-width: 440px) {
        .ehi-pillar-block{
            padding: 1.2rem 0;
        }
    }
    @media screen and (max-width: 767px) {
        #zipCode {
            width: 100%;
        }
        .error-message {
            position: relative;
            margin-top: 12px;
        }
        #cta-btn {
            width: 100%;
        }
        .county-select {
            width: 100%;
        }
        .hydrated {
            width: 100%;
        }
    }
`

export default ({ category, id, headline, message, color, ctaBtn }) => {
    const [zipCode, setZipCode] = useState()
    const [zipCodeState, setZipCodeState] = useState([])
    const [selectedCounty, setSelectedCounty] = useState()
    const [empNum, setEmpNum] = useState()
    const [isZipCodeError, setIsZipCodeError] = useState(false)
    const [isEENumError, setIsEENumError] = useState(false)
    const [isDisable, setIsDisable] = useState(true)
    
    const validateZipCode = e => {
        const $currentEECountElement = document.getElementById('employeeNum');
        e.target.value = e.target.value.slice(0, 5)
        setZipCode(e.target.value)

        if (e.target.value > 9999 || `${e.target.value}` === "00000") {
            const zipCodeAPI = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/ifp-api/misc/zip/zipInfo?zips=${
                e.target.value
            }`
            axios.get(zipCodeAPI).then(response => {
                const resultObj = response.data[0]
                const resultStates = resultObj.states || []
                if (resultObj.stateAbbr && resultObj.states) {
                    setIsZipCodeError(false)
                    if(category !== 'group-dental-insurance' && category !== 'group-vision-insurance') {
                        setIsDisable(false)
                    } else {
                        if(!isEENumError && $currentEECountElement.value !== '') {
                            setIsDisable(false)
                        }
                    }
                    setZipCodeState(resultStates)
                    setSelectedCounty(resultStates[0].county)
                } else {
                    setIsZipCodeError(true)
                    setIsDisable(true)
                }
            })
        } else {
            setIsDisable(true)
        }
    }
    const zipCodeLengthCheck = e => {
        if (e.target.value.length < 5) {
            setIsZipCodeError(true)
            
        }
        validateZipCode(e)
    }
    const empNumCheck = e => {
        const $currentZipCodeElement = document.getElementById('zipCode');
        if (e.target.value === '0' || e.target.value === '') {
            setIsEENumError(true);
            setIsDisable(true)
        } else {
            setIsEENumError(false);
            setEmpNum(e.target.value);
            if(!isZipCodeError && $currentZipCodeElement.value !== '') {
                setIsDisable(false)
            }
        }
    }
    
    const handleSubmit = e => {
        e.preventDefault();
        if (!zipCode || zipCode.length < 5 || zipCode === "00000") return
        if (!isZipCodeError) {
            const quoteZipCode = zipCode ? zipCode : ""
            const allId = getCookie("ehi.alliance_id")
            let targetURL = '';
            if(category === 'group-dental-insurance' || category === 'group-vision-insurance') {
                if (!empNum || empNum.length < 0) return
                if (!isEENumError) {
                    switch (category) {
                        case "group-dental-insurance":
                            targetURL = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                                ""}ehealthinsurance.com/group-dental-insurance?zipCode=${quoteZipCode}&employeeEnrollingNumber=${empNum}${allId ? `&allid=${allId}` : ""}`
                            break;
                        case "group-vision-insurance":
                            targetURL = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                                ""}ehealthinsurance.com/group-vision-insurance?zipCode=${quoteZipCode}&employeeEnrollingNumber=${empNum}${allId ? `&allid=${allId}` : ""}`
                            break;
                        default:
                            targetURL = `https://www.${process.env
                                .GATSBY_SUBDOMAIN ||
                                ""}ehealthinsurance.com/small-business-health-insurance?zipCode=${quoteZipCode}&employeeEnrollingNumber=${empNum}${allId ? `&allid=${allId}` : "" }`
                            break;
                    }
                }
            } else {
                switch (category) {
                    case "individual-and-family":
                        targetURL = `https://www.${process.env
                            .GATSBY_SUBDOMAIN ||
                            ""}ehealthinsurance.com/individual-family-health-insurance/plans?zipCode=${quoteZipCode}${allId ? `&allid=${allId}` : ""}${selectedCounty ? `&county=${selectedCounty}` : ""}`
                        break;
                    case "small-business":
                        targetURL = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                            ""}ehealthinsurance.com/small-business-health-insurance/group-health-insurance-plans?zipCode=${quoteZipCode}${allId ? `&allid=${allId}` : ""}`
                        break;
                    case "medicare":
                        targetURL = `https://www.${process.env.GATSBY_SUBDOMAIN || ""}ehealthmedicareplans.com/v2?zip=${quoteZipCode}`
                        break;
                    case "coronavirus-updates":
                        targetURL = `https://www.${process.env.GATSBY_SUBDOMAIN || ""}ehealthinsurance.com${allId ? `?allid=${allId}` : "" }`
                        break;
                    case "dental-insurance":
                        targetURL = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                            ""}ehealthinsurance.com/dental-insurance/find-dental-coverage?action=changeCensus&zipCode=${quoteZipCode}${allId ? `&allid=${allId}` : ""}`
                        break;
                    case "vision-insurance":
                        targetURL = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                            ""}ehealthinsurance.com/vision-insurance/find-coverage?action=changeCensus&zipCode=${quoteZipCode}${allId ? `&allid=${allId}` : ""}`
                        break;
                    default:
                        targetURL = `https://www.${process.env
                            .GATSBY_SUBDOMAIN ||
                            ""}ehealthinsurance.com/individual-family-health-insurance/plans?zipCode=${quoteZipCode}${allId ? `&allid=${allId}` : "" }${selectedCounty ? `&county=${selectedCounty}` : ""}`
                        break;
                }
            }
            window.location.href = targetURL;
        }
    }
    return (
        <BlogCta id={id} className={color}>
            <div className="ehi-pillar-block text-center">
                <h2 className="mb-3">{headline || 'Compare and find affordable health insurance.'}</h2>
                <p className="my-3">{message || ''}</p>
                <div className="d-flex justify-content-center">
                    <div className="hydrated">
                        <form onSubmit={e => handleSubmit(e)} autoComplete="off" className="quote-form d-md-flex justify-content-center justify-content-md-start align-items-end mb-4" autoComplete="off">
                            <div className="form-group mb-md-0 mr-md-2 zipcode">
                                <label className="text-left" htmlFor="zipCode">Zipcode</label>
                                <input id="zipCode" type="number"
                                    onInput={e => validateZipCode(e)}
                                    onBlur={e => zipCodeLengthCheck(e)}/>
                                {isZipCodeError && (
                                    <div className="error-message text-left">
                                        Typo? Zip code is not valid.
                                    </div>
                                )}
                            </div>
                            {zipCodeState.length > 1 && (
                                <div className="form-group mb-md-0 mr-md-2 county">
                                <label className="text-left" htmlFor="zipCode">County</label>
                                <select id="zip-county" name="county" className="county-select" onChange={(e) => {
                                    if(e.target.value !== '0') {
                                        setSelectedCounty(e.target.value)
                                    }
                                }}>
                                    {zipCodeState.map((state, index) => {
                                        return (
                                            <option key={index} value={state.county}>
                                                {state.county}
                                            </option>
                                        )
                                    })}
                                </select>
                                {isZipCodeError && (
                                    <div className="error-message text-left">
                                        Please select a county.
                                    </div>
                                )}
                            </div>
                            )}
                            
                            {(category === 'group-dental-insurance' || category === 'group-vision-insurance') &&
                                (<div className="form-group mb-md-0 mr-md-2 employee-num">
                                    <label className="text-left" htmlFor="employee-num"># of employees<span>(including yourself)</span></label>
                                    <input id="employeeNum" type="number"
                                        defaultValue={empNum}
                                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                        onKeyUp={e => empNumCheck(e)}
                                        onInput={(e) =>
                                        e.target.value > 999
                                            ? (e.target.value = e.target.value.slice(0, 3))
                                            : e.target.value}/>
                                    {isEENumError && (
                                        <div id="invalid-ee-num" className="error-message text-left">How many employees including yourself?</div>
                                    )}
                                </div>)
                            }
                            <input type="submit" id="cta-btn" className="button-primary" value={ctaBtn || 'Find Plans'} disabled={isDisable}/>
                        </form>
                    </div>
                </div>
            </div>
        </BlogCta>
    )
}
